/** Get Dashboard Chart data */
export const GET_THRESHOLD_SUCCESS = "GET_THRESHOLD_SUCCESS";
export const GET_THRESHOLD_FAIL = "GET_THRESHOLD_FAIL";
export const GET_THRESHOLD = "GET_THRESHOLD";
export const GET_DYNAMIC_THRESHOLD = "GET_DYNAMIC_THRESHOLD";
export const GET_DYNAMIC_THRESHOLD_SUCCESS = "GET_DYNAMIC_THRESHOLD_SUCCESS";
export const GET_DYNAMIC_THRESHOLD_FAIL = "GET_DYNAMIC_THRESHOLD_FAIL";
export const POST_ALERT_SETUP = "POST_ALERT_SETUP";
export const POST_ALERT_SETUP_FAIL = "POST_ALERT_SETUP_FAIL";
export const POST_DISABLE_THRESHOLD_ALERTS = "POST_DISABLE_THRESHOLD_ALERTS";
export const POST_DISABLE_THRESHOLD_ALERTS_FAIL = "POST_DISABLE_THRESHOLD_ALERTS_FAIL";
export const POST_ENABLE_THRESHOLD_ALERTS = "POST_ENABLE_THRESHOLD_ALERTS";
export const POST_ENABLE_THRESHOLD_ALERTS_FAIL = "POST_ENABLE_THRESHOLD_ALERTS_FAIL";

export const GET_SERVICE_QUOTA_THRESHOLD = "GET_SERVICE_QUOTA_THRESHOLD";
export const GET_SERVICE_QUOTA_THRESHOLD_SUCCESS = "GET_SERVICE_QUOTA_THRESHOLD_SUCCESS";
export const GET_SERVICE_QUOTA_THRESHOLD_FAIL = "GET_SERVICE_QUOTA_THRESHOLD_FAIL";

export const GET_QUOTA_MASTER_RESOURCES = "GET_QUOTA_MASTER_RESOURCES";
export const GET_QUOTA_MASTER_RESOURCES_SUCCESS = "GET_QUOTA_MASTER_RESOURCES_SUCCESS";
export const GET_QUOTA_MASTER_RESOURCES_FAIL = "GET_QUOTA_MASTER_RESOURCES_FAIL";

export const DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS = "DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS";
export const DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_SUCCESS = "DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_SUCCESS";
export const DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_FAIL = "DEPLOY_MASTER_RESOURCE_QUOTA_ALERTS_FAIL";

export const UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG = "UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG";
export const UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_SUCCESS = "UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_SUCCESS";
export const UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_FAIL = "UPDATE_QUOTA_MASTER_RESOURCE_ALERTS_CONFIG_FAIL";

export const GET_DEPLOYED_SERVICE_QUOTA_ALERTS = "GET_DEPLOYED_SERVICE_QUOTA_ALERTS";
export const GET_DEPLOYED_SERVICE_QUOTA_ALERTS_SUCCESS = "GET_DEPLOYED_SERVICE_QUOTA_ALERTS_SUCCESS";
export const GET_DEPLOYED_SERVICE_QUOTA_ALERTS_FAIL = "GET_DEPLOYED_SERVICE_QUOTA_ALERTS_FAIL";

export const UPDATE_DEPLOYED_ALERT = "UPDATE_DEPLOYED_ALERT";
export const UPDATE_DEPLOYED_ALERT_SUCCESS = "UPDATE_DEPLOYED_ALERT_SUCCESS";
export const UPDATE_DEPLOYED_ALERT_FAIL = "UPDATE_DEPLOYED_ALERT_FAIL";